import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20minimalist%20serene%20training%20space%20with%20a%20person%20in%20deep%20focus%20meditation%20pose%20warm%20amber%20sunset%20light%20streaming%20through%20large%20windows%20clean%20modern%20interior%20with%20wooden%20floor%20calm%20atmosphere%20cinematic%20composition%20soft%20atmospheric%20glow&width=1600&height=900&seq=cunzhi-hero-bg&orientation=landscape"
          alt="寸止挑战训练场景"
          className="w-full h-full object-cover object-top"
          title="寸止挑战 - 极限控制力训练"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45" />
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 text-background-50 text-sm mb-6">
          <i className="ri-fire-line text-primary-400" />
          <span>2026年最受欢迎的挑战训练项目</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-6 leading-tight">
          寸止挑战
          <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-3 text-background-200">
            极限控制力测试全攻略
          </span>
        </h1>

        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-10 leading-relaxed">
          一项考验极限控制力与专注度的热门挑战项目。深度解析规则玩法、技巧训练、常见误区与进阶方法，帮助挑战者突破自我极限，掌握真正的寸止精髓。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/rumen-jiaocheng"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            新手入门指南
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/category/jinjie-gonglve"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-background-50/10 backdrop-blur-sm text-background-50 font-semibold text-sm border border-background-50/30 hover:bg-background-50/20 transition-colors whitespace-nowrap"
          >
            高手进阶攻略
            <i className="ri-rocket-line" />
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-12 text-background-300 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-article-line text-primary-400" />
            <span>30+ 篇专业文章</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-group-line text-primary-400" />
            <span>50,000+ 挑战者</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-star-line text-primary-400" />
            <span>4.8 分好评</span>
          </div>
        </div>
      </div>
    </section>
  );
}